import styled from 'styled-components';
import { Body, Icon, Theme } from '@routific/hive';

export const StyledMessageBody = styled(Body)`
    font-size:16px;
`;

export const StyledMessageIcon = styled(Icon)`
    padding-right: ${Theme.Spacing.xsSpacing};
    padding-bottom: 3px;
    font-size: 16px;
    vertical-align: middle;
`;
